import { CommonModule } from '@angular/common';
import { Component, Input, forwardRef } from '@angular/core';
import { ControlValueAccessor, FormsModule, NG_VALUE_ACCESSOR } from '@angular/forms';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { SVGImageComponent } from '@app/components/svg-image/svg-image.component';
import { PlatformModule } from '@app/platform.module';
import { TranslatableKey } from '@app/types/translatable.type';
import { TranslateModule } from '@ngx-translate/core';

@Component({
    selector: 'app-image-toggle',
    templateUrl: './image-toggle.template.html',
    styleUrls: ['./image-toggle.style.scss'],
    standalone: true,
    imports: [TranslateModule, CommonModule, MatSlideToggleModule, PlatformModule, FormsModule, SVGImageComponent],
    providers: [{ provide: NG_VALUE_ACCESSOR, useExisting: forwardRef(() => ImageToggleComponent), multi: true }],
})
export class ImageToggleComponent implements ControlValueAccessor {
    private static nextId = 0;

    @Input() id = `imageToggle-${(ImageToggleComponent.nextId += 1)}`;
    @Input() label?: TranslatableKey;
    @Input() src?: string;
    @Input() required?: boolean;
    @Input() disabled?: boolean;
    @Input() isLoading?: boolean;
    @Input() hideToggle?: boolean;

    onTouched?: (event: Event) => void;
    onChange?: (value: boolean) => void;
    private _checked = false;

    set checked(checked: boolean) {
        this._checked = checked;
        this.onChange?.(checked);
    }

    get checked(): boolean {
        return this._checked;
    }

    onToggle(value: boolean): void {
        this.onChange?.(value);
    }

    writeValue(value: boolean): void {
        this._checked = value;
    }

    registerOnChange(fn: (value: boolean) => void): void {
        this.onChange = fn;
    }
    registerOnTouched(fn: (event: Event) => void): void {
        this.onTouched = fn;
    }
}
